import React from 'react';
import PropTypes from 'prop-types';

// Components
import MadeInSocialHousingImagesHero from './made-in-social-housing/hero-images';
import MadeInSocialHousingVideoHero from './made-in-social-housing/hero-video';
import LetsBuildSocialHousingHero from './lets-build-social-housing';

const CustomHero = ({ content }) => {
  const { type } = content;

  switch (type) {
    case `Lets Build Social Housing`:
      return <LetsBuildSocialHousingHero content={content} />;
    case `Made in Social Housing - Images`:
      return <MadeInSocialHousingImagesHero content={content} />;
    case `Made in Social Housing - Video`:
      return <MadeInSocialHousingVideoHero content={content} />;
    default:
      // 'General' - We can build other versions in the future here
      return <LetsBuildSocialHousingHero content={content} />;
  }
};

CustomHero.propTypes = {
  content: PropTypes.shape({
    type: PropTypes.oneOf([
      'General',
      'Made in Social Housing - Images',
      'Made in Social Housing - Video',
    ]).isRequired,
  }),
};

export default CustomHero;
